// action types
import { createRequestTypes } from "../../utils";

// Label Brands
export const GET_LABEL_BRANDS = createRequestTypes("GET_LABEL_BRANDS");

// Label Sizes
export const GET_LABEL_SIZES = createRequestTypes("GET_LABEL_SIZES");
export const GET_LABEL_SIZE = createRequestTypes("GET_LABEL_SIZE");
export const CREATE_LABEL_SIZE = createRequestTypes("CREATE_LABEL_SIZE");

// Batch Label Data
export const GET_BATCH_LABEL_DATA = createRequestTypes("GET_BATCH_LABEL_DATA");

// Spawn Source Label Data
export const GET_SPAWN_SOURCE_LABEL_DATA = createRequestTypes("GET_SPAWN_SOURCE_LABEL_DATA");

// Fields Config
export const GET_LABEL_FIELDS_CONFIG = createRequestTypes("GET_LABEL_FIELDS_CONFIG");

// Label Categories
export const GET_LABEL_CATEGORIES = createRequestTypes("GET_LABEL_CATEGORIES");

// UI state
export const SET_SELECTED_LABEL_SIZE = 'SET_SELECTED_LABEL_SIZE';
export const RESET_LABELS_STATE = 'RESET_LABELS_STATE';
export const CLEAR_LABEL_DATA = 'CLEAR_LABEL_DATA';

// ----------------------------------------------------------------------
// Action Creators - Label Brands
// ----------------------------------------------------------------------

export const getLabelBrandsRequest = () => ({
  type: GET_LABEL_BRANDS.REQUEST,
});

export const getLabelBrandsSuccess = (data) => ({
  type: GET_LABEL_BRANDS.SUCCESS,
  payload: { data },
});

export const getLabelBrandsFailure = (error) => ({
  type: GET_LABEL_BRANDS.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Label Sizes
// ----------------------------------------------------------------------

export const getLabelSizesRequest = (params = {}) => ({
  type: GET_LABEL_SIZES.REQUEST,
  payload: params,
});

export const getLabelSizesSuccess = (data) => ({
  type: GET_LABEL_SIZES.SUCCESS,
  payload: { data },
});

export const getLabelSizesFailure = (error) => ({
  type: GET_LABEL_SIZES.FAILURE,
  payload: error,
});

export const getLabelSizeRequest = (id) => ({
  type: GET_LABEL_SIZE.REQUEST,
  payload: id,
});

export const getLabelSizeSuccess = (data) => ({
  type: GET_LABEL_SIZE.SUCCESS,
  payload: { data },
});

export const getLabelSizeFailure = (error) => ({
  type: GET_LABEL_SIZE.FAILURE,
  payload: error,
});

export const createLabelSizeRequest = (data) => ({
  type: CREATE_LABEL_SIZE.REQUEST,
  payload: data,
});

export const createLabelSizeSuccess = (data) => ({
  type: CREATE_LABEL_SIZE.SUCCESS,
  payload: { data },
});

export const createLabelSizeFailure = (error) => ({
  type: CREATE_LABEL_SIZE.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Batch Label Data
// ----------------------------------------------------------------------

export const getBatchLabelDataRequest = (batchId) => ({
  type: GET_BATCH_LABEL_DATA.REQUEST,
  payload: batchId,
});

export const getBatchLabelDataSuccess = (data) => ({
  type: GET_BATCH_LABEL_DATA.SUCCESS,
  payload: { data },
});

export const getBatchLabelDataFailure = (error) => ({
  type: GET_BATCH_LABEL_DATA.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Spawn Source Label Data
// ----------------------------------------------------------------------

export const getSpawnSourceLabelDataRequest = (spawnSourceId) => ({
  type: GET_SPAWN_SOURCE_LABEL_DATA.REQUEST,
  payload: spawnSourceId,
});

export const getSpawnSourceLabelDataSuccess = (data) => ({
  type: GET_SPAWN_SOURCE_LABEL_DATA.SUCCESS,
  payload: { data },
});

export const getSpawnSourceLabelDataFailure = (error) => ({
  type: GET_SPAWN_SOURCE_LABEL_DATA.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Fields Config
// ----------------------------------------------------------------------

export const getLabelFieldsConfigRequest = () => ({
  type: GET_LABEL_FIELDS_CONFIG.REQUEST,
});

export const getLabelFieldsConfigSuccess = (data) => ({
  type: GET_LABEL_FIELDS_CONFIG.SUCCESS,
  payload: { data },
});

export const getLabelFieldsConfigFailure = (error) => ({
  type: GET_LABEL_FIELDS_CONFIG.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// Action Creators - Label Categories
// ----------------------------------------------------------------------

export const getLabelCategoriesRequest = () => ({
  type: GET_LABEL_CATEGORIES.REQUEST,
});

export const getLabelCategoriesSuccess = (data) => ({
  type: GET_LABEL_CATEGORIES.SUCCESS,
  payload: { data },
});

export const getLabelCategoriesFailure = (error) => ({
  type: GET_LABEL_CATEGORIES.FAILURE,
  payload: error,
});

// ----------------------------------------------------------------------
// UI State Actions
// ----------------------------------------------------------------------

export const setSelectedLabelSize = (labelSize) => ({
  type: SET_SELECTED_LABEL_SIZE,
  payload: labelSize,
});

export const resetLabelsState = () => ({
  type: RESET_LABELS_STATE,
});

export const clearLabelData = () => ({
  type: CLEAR_LABEL_DATA,
});
